import { render } from "./SlowFilterCard.vue?vue&type=template&id=4e10a4a6&scoped=true"
import script from "./SlowFilterCard.vue?vue&type=script&lang=js"
export * from "./SlowFilterCard.vue?vue&type=script&lang=js"

import "./SlowFilterCard.vue?vue&type=style&index=0&id=4e10a4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e10a4a6"]])

export default __exports__